import React from 'react';
import {Container, CardContainer} from '../../../components/Container';
import {H1} from '../../../components/Typography';
import {Helmet} from 'react-helmet';
import {withInstallation} from '../../../components/InstallationContext';

import RateCardDetailsForm from './DetailsForm';

function CreateRateCard({installation, history}) {
    function onDone(rateCard) {
        history.goBack(rateCard ? {
            flash: {
                flavour: 'success',
                message: `${rateCard.name} created successfully`,
                createdAt: Date.now(),
            },
        } : null);
    }

    return (
        <CardContainer>
            <Container  spaceBelow="medium">
                <Helmet>
                    <title>New guest card</title>
                </Helmet>
                <H1  spaceBelow="large">
                    New guest card
                </H1>
                <RateCardDetailsForm
                    installation={installation}
                    onSubmit={onDone}
                    onCancel={onDone}
                />
            </Container>
        </CardContainer>
    )
}

export default withInstallation(CreateRateCard);
